<template>
  <el-card>
    <span class="title">选课管理</span>

    <div class="box">
      <el-form
        ref="form_ref"
        :model="form"
        :rules="rules"
        label-width="56px"
        class="login_from"
        label-position="right"
      >

        <el-form-item label="年级" prop="grade">
          <el-select
            v-model="form.grade"
            placeholder="请选择年级"
            style="width:100%;"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="班级" prop="class">
          <el-select
            v-model="form.class"
            placeholder="请选择班级"
            style="width:100%;"
          >
            <el-option
              v-for="item in class_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程" prop="course">
          <el-select
            v-model="form.course"
            placeholder="请选择年级"
            style="width:100%;"
          >
            <el-option
              v-for="item in course_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="时间" prop="time">
          <el-date-picker
            v-model="form.time"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:100%;"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="老师" prop="teacher">
          <el-input v-model="form.teacher" placeholder="请输入老师姓名">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            v-if="!type_school"
            size="mini"
            type="primary"
            @click="onSubmit"
          >
            提交
          </el-button>

          <el-button type="primary" v-else size="mini" @click="onSubmit">
            修改
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import { getSchool } from "@/api/admin.js";
import {
  get_classinfo_api,
  post_classinfo_api,
  put_classinfo_api,
} from "@/api/select_course.js";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  data() {
    return {
      rules: {
        grade: [{ required: true, message: "请选择年级", trigger: "change" }],
        class: [{ required: true, message: "请选择班级", trigger: "change" }],
        course: [{ required: true, message: "请选择课程", trigger: "change" }],
        time: [{ required: true, message: "请选择时间", trigger: "change" }],
        teacher: [
          { required: true, message: "请输入老师姓名", trigger: "blur" },
        ],
      },

      form: {
        grade: "", //年级
        class: "", //班级
        course: "", //课程
        time: "", //时间
        teacher: "", //老师
      },

      form_id: "",

      school_id: "",

      options: [
        {
          value: "七年级",
          label: "七年级",
        },
        {
          value: "八年级",
          label: "八年级",
        },
        {
          value: "九年级",
          label: "九年级",
        },
      ],

      class_options: [
        {
          value: "一",
          label: "一",
        },
        {
          value: "二",
          label: "二",
        },
        {
          value: "三",
          label: "三",
        },
        {
          value: "四",
          label: "四",
        },
      ],

      course_options: [
        {
          value: "语文",
          label: "语文",
        },
        {
          value: "数学",
          label: "数学",
        },
        {
          value: "英语",
          label: "英语",
        },
        {
          value: "编程",
          label: "编程",
        },
      ],

      type_school: false,
    };
  },

  created() {
    // 获取校区
    let id = this.userInfo.user_role[0].Domain.Name;
    getSchool().then((res) => {
      if (res.data) {
        res.data.forEach((v) => {
          if (v.Name == id) {
            this.school_id = v.Id;
            get_classinfo_api(this.school_id).then((res) => {
              if (res.data) {
                let s = res.data[0];
                this.type_school = true;
                this.form_id = s.Id;
                this.form.grade = s.Grade;
                this.form.class = s.Class;
                this.form.course = s.Course;
                this.form.time = s.Time;
                this.form.teacher = s.Teacher;
              }
            });
          }
        });
        this.campusList = res.data;
      }
    });
  },

  methods: {
    //提交
    onSubmit() {
      this.$refs.form_ref.validate((valid) => {
        if (valid) {
          if (this.type_school) {
            put_classinfo_api(this.form_id, this.form).then((res) => {
              this.$message.success("修改成功！");
            });
          } else {
            post_classinfo_api(this.school_id, this.form).then((res) => {
              this.type_school = true;
              this.form_id = res.data.Id;
              this.$message.success("提交成功！");

            });
          }
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }
    .box {
        margin-top :30px;
        width:30%;
    }
}
</style>
